import { Component, Input, OnInit } from '@angular/core';
import { MessageElement } from '../model';

@Component({
  selector: 'app-upload-picker',
  templateUrl: './upload-picker.component.html',
  styleUrls: ['./upload-picker.component.css']
})
export class UploadPickerComponent implements OnInit {
  @Input()  data?:MessageElement;
  constructor() { }

  ngOnInit(): void {
  }

}
